<template>
  <div>
    <home-first></home-first>
  </div>
</template>

<script>
import homeFirst from './view/home.vue'

export default {
  name: 'App',
  components: {
    homeFirst,
  },
  mounted() {
    document.title = "普柏聖實業有限公司";  // 在这里设置
  }
}
</script>

<style>
</style>
